import React from 'react';
import { MessageBox, MessageBoxProps } from 'components/_new/MessageBox';

type PinkProps = Omit<MessageBoxProps, 'title' | 'variant'>;

export const Pink = (props: PinkProps) => {
	return <MessageBox variant="pink" {...props} />;
};
